<template>
    <div class="columns is-mobile is-centered has-background-primary p-2" v-if="props.titoloVisibile==true">
        <h1 class="title is-4 has-text-white">PREVENTIVI</h1>
    </div>

    <!--********** CAMPO DI RICERCA **********-->
    <div class="columns is-mobile is-centered" v-if="props.campoRicercaVisibile==true">
        <div class="column is-5">
                <input class="input is-primary" type="text" v-model="testoRicerca" placeholder="Cerca..." @keyup.enter="bCerca(['oggetto', 'numero', 'anno'])">
        </div>
        <div class="column is-1" v-if="props.campoRicercaVisibile==true">
            <a class="button is-primary is-outlined" title="Ricerca completa" @click="bCerca(['JSON'])">
                <span class="icon"><i class="fas fa-eye"></i></span>
            </a>
        </div>
    </div>

    <!--********** TABELLA PREVENTIVI **********-->
    <div class="blocco-scroll">
        <table class="table is-striped mx-auto">
            <thead>
                <tr>
                    <th class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaPreventivo(-1)" v-if="props.bottoneAggiungiVisibile==true">
                            <span class="icon"><i class="fas fa-plus"></i></span>
                        </button>
                    </th>
                    <th v-if="mostraInfoSviluppo"></th>
                    <th class="has-text-centered" v-if="mostraInfoSviluppo">Id</th>
                    <th class="has-text-centered">Anno</th>
                    <th class="has-text-centered">Numero</th>
                    <th class="has-text-centered">Data</th>
                    <th v-if="props.lead==null">Lead</th>
                    <th>Oggetto</th>
                    <th>Importo</th>
                    <th class="has-text-centered" title="Inviato">I</th>
                    <th class="has-text-centered" title="Attivo">A</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(pr, index) in elencoPreventivi" :key="leggiInfoDB(pr).id">
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaPreventivo(leggiInfoDB(pr).id, leggiInfoDB(pr).idLead, leggiInfoDB(pr).idCliente)">
                            <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
                        </button>
                    </td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{index + 1}}</td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{leggiInfoDB(pr).id}}</td>
                    <td class="has-text-centered">{{dataDaTimestamp(pr.data, 'anno')}}</td>
                    <td class="has-text-centered">{{pr.numero}}</td>
                    <td>{{dataDaTimestamp(pr.data, 'testo')}}</td>
                    <td v-if="props.lead==null"><a @click="emit('elementoSelezionato', {tipo: 'lead', idCliente: leggiInfoDB(pr).idCliente, idLead: leggiInfoDB(pr).idLead})">{{leggiInfoDB(pr).stringaLead}}</a></td>
                    <td>{{pr.oggetto}}</td>
                    <td class="has-text-right">{{generaStringa(pr.importo, '0,00')}}</td>
                    <td class="has-text-centered">
                        <ComponenteIcona :nome="pr.inviato? 'Inviato': ''" />
                    </td>
                    <td class="has-text-centered">
                        <ComponenteIcona :nome="pr.attivo? 'Attivo': ''" />
                    </td>
                </tr>
                <tr v-if="props.lead!=null">
                    <td></td>
                    <td v-if="mostraInfoSviluppo"></td>
                    <td v-if="mostraInfoSviluppo"></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td v-if="props.lead==null"></td>
                    <td>Totale preventivi</td>
                    <td class="has-text-right">{{generaStringa(leggiInfoDB(dbClienti[props.cliente].leads[props.lead]).totPreventivi, '0,00')}}</td>
                    <td></td>
                </tr>
                <tr v-if="props.lead!=null">
                    <td></td>
                    <td v-if="mostraInfoSviluppo"></td>
                    <td v-if="mostraInfoSviluppo"></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td v-if="props.lead==null"></td>
                    <td>Totale preventivi attivi</td>
                    <td class="has-text-right">{{generaStringa(leggiInfoDB(dbClienti[props.cliente].leads[props.lead]).totPreventiviAttivi, '0,00')}}</td>
                    <td></td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="has-text-centered" colspan="2">{{stringaNumeroRecord}}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script setup>
    import ComponenteIcona from "./ComponenteIcona.vue";
    import { defineProps, defineEmits, computed, ref } from "vue";
    import { dataDaTimestamp, generaStringa, mostraInfoSviluppo, getValorePerOrdinamento } from "./../code/utilita";
    import { dbClienti, leggiInfoDB, leggiInfoDBRaw } from "@/code/gestioneDB";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        cliente: {
            type: Number,
            default: null },
        lead: {
            type: Number,
            default: null },
        testoDaCercare: {
            type: String,
            default: null },
        campiDaCercare: {
            type: Array,
            default:  () => {return ['oggetto', 'numero', 'anno']}
        },
        bottoneAggiungiVisibile: {
            type: Boolean,
            default: false },
        campoRicercaVisibile: {
            type: Boolean,
            default: true },
        titoloVisibile: {
            type: Boolean,
            default: true }
    });
    const emit = defineEmits(['elementoSelezionato','statoInterfacciaCambiato']);

    // VARIABILI DEL COMPONENTE
    const testoRicerca = ref(props.testoDaCercare);
    const stringaNumeroRecord = ref("");

    const elencoPreventivi = computed(()=>{
        let tempElencoPreventivi = [];
        if (props.lead==null) {
            if (props.cliente==null) {
                for(const cl in dbClienti.value){
                    for(const ld in  dbClienti.value[cl].leads){
                        for(const pr in  dbClienti.value[cl].leads[ld].preventivi){
                            tempElencoPreventivi.push(dbClienti.value[cl].leads[ld].preventivi[pr]);
                        }
                    }
                }
            } else {
                for(const ld in  dbClienti.value[props.cliente].leads){
                    for(const pr in  dbClienti.value[props.cliente].leads[ld].preventivi){
                        tempElencoPreventivi.push(dbClienti.value[props.cliente].leads[ld].preventivi[pr]);
                    }
                }
            }
        } else {
            const cl = props.cliente;
            const ld = props.lead;
            for(const pr in  dbClienti.value[cl].leads[ld].preventivi){
                tempElencoPreventivi.push(dbClienti.value[cl].leads[ld].preventivi[pr]);
            }
        }
        ordinaElencoPreventivi(tempElencoPreventivi);
        filtraElencoElementi(tempElencoPreventivi, props.testoDaCercare, props.campiDaCercare);
        return tempElencoPreventivi;
    });

    // SETUP DEL COMPONENTE

    // FUNZIONI DEL COMPONENTE

    function bCerca(campi) {
        emit('statoInterfacciaCambiato', {testoRicercaPreventivi: testoRicerca.value, campiRicercaPreventivi: campi});
        // emit('statoInterfacciaCambiato', {testoRicercaPreventivi: testoRicerca.value});
    }

    function bSelezionaPreventivo(idPr, idLd, idCl) {
        let tempIdCl;
        let tempIdLd;
        tempIdCl = props.cliente==null ? idCl : props.cliente;
        tempIdLd = props.lead==null ? idLd : props.lead;
        emit('elementoSelezionato', {
            tipo: 'preventivo',
            idCliente: tempIdCl,
            idLead: tempIdLd,
            idPreventivo: idPr
        });
    }

    function ordinaElencoPreventivi(elenco) {
        // Ordina elenco in ordine di anno (decrescente) e di numero (decrescente)
        elenco.sort((a, b) => {
            
            // 1. Estrazione sicura dei millisecondi (gestisce sia Firestore che JSON Storage)
            const msA = getValorePerOrdinamento(a, 'data', false) || 0;
            const msB = getValorePerOrdinamento(b, 'data', false) || 0;

            // 2. Calcolo nativo e sicuro dell'anno (se ms è 0, assegna anno 0)
            const annoA = msA > 0 ? new Date(msA).getFullYear() : 0;
            const annoB = msB > 0 ? new Date(msB).getFullYear() : 0;

            // 3. Ordinamento Primario: per Anno (dal più recente al più vecchio)
            if (annoA !== annoB) {
                return annoB - annoA;
            }

            // 4. Ordinamento Secondario: per Numero (dal più grande al più piccolo)
            // Usiamo Number() per prevenire bug se il numero fosse salvato come stringa
            const numA = Number(getValorePerOrdinamento(a, 'numero', false)) || 0;
            const numB = Number(getValorePerOrdinamento(b, 'numero', false)) || 0;

            return numB - numA;
        });

        return elenco;
    }

    function filtraElencoElementi(elencoEl, testo, campi) {
        // Filtra viewPreventivi cercando il testo nei campi indicati dall'array di stringhe 'campi'
        const tempStringaNumeroRecord = elencoEl.length;
        if ( testo ) {
            for (let i=0; i < elencoEl.length; i++) {
                const regexCerca = new RegExp(testo, 'i');
                let temp = null;
                let pos = -1;
                if ( campi[0] == 'JSON' ) {
                    // Ricerca profonda
                    temp = JSON.stringify(elencoEl[i]);
                    pos = temp.search(regexCerca);
                    // Ricerca nelle info del preventivo
                    if (pos==-1) {
                        temp = leggiInfoDBRaw(elencoEl[i]).stringaLead;
                        pos = temp.search(regexCerca);
                    }
                } else {
                    for (const cc in campi) {
                        if (pos == -1) {
                            if ( Array.isArray(campi[cc]) ) {
                                temp = elencoEl[i][campi[cc][0]][campi[cc][1]];
                            } else if ( campi[cc] == 'anno' ) {
                                temp = dataDaTimestamp(elencoEl[i].data, 'anno');
                            } else {
                                temp = elencoEl[i][campi[cc]];
                            }
                            pos = String(temp).search(regexCerca);
                        }
                    }
                    // Ricerca nelle info del preventivo
                    if (pos==-1) {
                        temp = leggiInfoDBRaw(elencoEl[i]).stringaLead;
                        pos = temp.search(regexCerca);
                    }
                }
                if (pos == -1) {
                    elencoEl.splice(i,1);
                    i--;
                }
            }
        }
        if (elencoEl.length>30){
            elencoEl.splice(25,(elencoEl.length-25));
        }
        stringaNumeroRecord.value = elencoEl.length + " di " + tempStringaNumeroRecord;
    }
</script>

<style>
    .table th.prima-riga {
        border: none;
    }
    .table th.bordi-laterali {
        border-left: 1px solid #dbdbdb;
        border-right: 1px solid #dbdbdb;
        /* border-width: 0 0 1px; */
    }
</style>